import {
		FORBIDDEN_ERROR,
		CLEAR_STORE,
        STAGES_SUCCESS,
        STAGES_REQUEST,
        LEVELS_SUCCESS,
        LEVELS_REQUEST,
        SINGLE_LEVEL_SUCCESS,
        SINGLE_LEVEL_REQUEST,
        ACCOUNTS_SUCCESS,
        ACCOUNTS_REQUEST,
		USERS_REQUEST,
		USERS_SUCCESS,
		CURRENCIES_REQUEST,
		CURRENCIES_SUCCESS,
		COUNTRIES_REQUEST,
		COUNTRIES_SUCCESS,
		SCHOOLTYPES_REQUEST,
		SCHOOLTYPES_SUCCESS,
		CLASSROOMS_REQUEST,
		CLASSROOMS_SUCCESS,
		PLAYERS_REQUEST,
		PLAYERS_SUCCESS,
		TEACHERS_REQUEST,
        TEACHERS_SUCCESS,
        SETTINGS_REQUEST,
        SETTINGS_SUCCESS,
        BADGES_REQUEST,
        BADGES_SUCCESS,
        PARTS_REQUEST,
        PARTS_SUCCESS
    } from '../actions/contentActions'

export const clearStoreReducer =  (state = null, action) => {
    let data = null;
    switch (action.type) {
		case CLEAR_STORE:
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const stagesReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case STAGES_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case STAGES_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
		case FORBIDDEN_ERROR:
			let error = action.err ? action.err.message : 'Internal Server Error'
			if(error == 'Forbidden'){
                error = 'Forbidden error'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const levelsReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case LEVELS_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case LEVELS_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
		case FORBIDDEN_ERROR:
			let error = action.err ? action.err.message : 'Internal Server Error'
			if(error == 'Forbidden'){
                error = 'Forbidden error'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const singleLevelReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case SINGLE_LEVEL_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case SINGLE_LEVEL_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
		case FORBIDDEN_ERROR:
			let error = action.err ? action.err.message : 'Internal Server Error'
			if(error == 'Forbidden'){
                error = 'Forbidden error'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const accountsReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case ACCOUNTS_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case ACCOUNTS_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const usersReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case USERS_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case USERS_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const currenciesReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case CURRENCIES_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case CURRENCIES_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const countriesReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case COUNTRIES_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case COUNTRIES_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const schoolTypesReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case SCHOOLTYPES_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case SCHOOLTYPES_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
		case FORBIDDEN_ERROR:
			let error = action.err? action.err.message : 'Internal Server Error'
			if(error == 'Forbidden'){
                error = 'Forbidden error'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const classRoomsReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case CLASSROOMS_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case CLASSROOMS_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
		case FORBIDDEN_ERROR:
			let error = action.err? action.err.message : 'Internal Server Error'
			if(error == 'Forbidden'){
                error = 'Forbidden error'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const playersReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case PLAYERS_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case PLAYERS_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
		case FORBIDDEN_ERROR:
			let error = action.err? action.err.message : 'Internal Server Error'
			if(error == 'Forbidden'){
                error = 'Forbidden error'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const teachersReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case TEACHERS_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case TEACHERS_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
		case FORBIDDEN_ERROR:
			let error = action.err? action.err.message : 'Internal Server Error'
			if(error == 'Forbidden'){
                error = 'Forbidden error'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const settingsReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case SETTINGS_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case SETTINGS_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
		case FORBIDDEN_ERROR:
			let error = action.err? action.err.message : 'Internal Server Error'
			if(error == 'Forbidden'){
                error = 'Forbidden error'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const badgesReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case BADGES_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case BADGES_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
		case FORBIDDEN_ERROR:
			let error = action.err? action.err.message : 'Internal Server Error'
			if(error == 'Forbidden'){
                error = 'Forbidden error'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        default:
            return state;
    }
}

export const partsReducer = (state = null, action) => {
    let data = null;
    switch (action.type) {
        case PARTS_REQUEST:
            return Object.assign({}, state, {isFetching: true})
        case PARTS_SUCCESS:
            data = action.data;
            data.isFetching = false
            return Object.assign({}, state, data)
		case FORBIDDEN_ERROR:
			let error = action.err? action.err.message : 'Internal Server Error'
			if(error == 'Forbidden'){
                error = 'Forbidden error'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/contentReducers.js